import { render, staticRenderFns } from "./CostoDestajo.vue?vue&type=template&id=7e7c0bc5&"
import script from "./CostoDestajo.vue?vue&type=script&lang=js&"
export * from "./CostoDestajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports